import { FormInput } from '..';

export const FormTextArea = FormInput.withComponent('textarea');
